export default __webpack_public_path__ + "static/media/signature_giovanna.4371f8de.png";